// extracted by mini-css-extract-plugin
export default {"label":"Label_label__uA7HL","auto":"Label_auto__81Q6l","large":"Label_large__mFBC+","required":"Label_required__BE7db"};